<script>
import Multiselect from 'vue-multiselect'
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import disease from '../../helpers/list/pilgrimage/disease.json';

export default {
  components: { Multiselect },
  props: {},

  data() {
    return {
      beneficiary_full_name: "",
      phone: "",
      relation_relative: "",
      is_have_disease: "",
      diseases: [],
      note: "",

      //lists
      list_disease: disease,
    };
  },
  validations: {
    beneficiary_full_name: { required, minLength: minLength(8), maxLength: maxLength(50) },
    phone: { required, minLength: minLength(11), maxLength: maxLength(11) },
    relation_relative: { required, minLength: minLength(2), maxLength: maxLength(15) },
    is_have_disease: { required },
    diseases: {},
    note: { maxLength: maxLength(500) },
    form: [
      "relation_relative",
      "beneficiary_full_name",
      "phone",
      "is_have_disease",
      "diseases",
      "note",
    ],
  },
  methods: {
    // validate
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    },
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <div class="row">
      <!-- title -->
      <hr class="hr-title" />
      <div class="break-title"><h5 class="mb-4">بيانات الطوارئ</h5></div>

      <b-form-group class="col-md-4 mb-3" label="الاسم الثلاثي للتواصل في حالة الطوارئ : " label-for="beneficiary_full_name">
        <b-form-input
          id="beneficiary_full_name"
          type="text"
          placeholder="ادخل الاسم الثلاثي للتواصل في حالة الطوارئ"
          v-model="beneficiary_full_name"
          :class="{ 'is-invalid': $v.beneficiary_full_name.$error }"
        ></b-form-input>
        <div v-if="$v.beneficiary_full_name.$error" class="invalid-feedback">
          <span v-if="!$v.beneficiary_full_name.required">هذا الحقل الزامي</span>
          <span v-if="!$v.beneficiary_full_name.minLength">يجب أن يتكون  الاسم الثلاثي من 8 حرف على الأقل</span>
          <span v-if="!$v.beneficiary_full_name.maxLength">يجب أن يتكون  الاسم الثلاثي من 50 حرف على الاكثر</span>
        </div>
      </b-form-group>
      
      <b-form-group class="col-md-4 mb-3" label="صلة القرابة : " label-for="relation_relative">
        <b-form-input
          id="relation_relative"
          type="text"
          placeholder="ادخل صلة القرابة"
          v-model="relation_relative"
          :class="{ 'is-invalid': $v.relation_relative.$error }"
        ></b-form-input>
        <div v-if="$v.relation_relative.$error" class="invalid-feedback">
          <span v-if="!$v.relation_relative.required">هذا الحقل الزامي</span>
          <span v-if="!$v.relation_relative.minLength">يجب أن تتكون صلة القرابة من حرفين على الأقل</span>
          <span v-if="!$v.relation_relative.maxLength">يجب أن تتكون صلة القرابة من 15 حرف على الاكثر</span>
        </div>
      </b-form-group>
      
      <b-form-group class="col-md-4 mb-3" label=" رقم الهاتف : " label-for="phone" >
        <b-form-input
          id="phone"
          type="number"
          placeholder="ادخل رقم الهاتف"
          v-model="phone"
          :class="{ 'is-invalid': $v.phone.$error }"
        ></b-form-input>
        <div v-if="$v.phone.$error" class="invalid-feedback">
          <span v-if="!$v.phone.required">هذا الحقل الزامي</span>
          <span v-if="!$v.phone.minLength">يجب أن يتكون رقم الهاتف من 11 رقم على الأقل</span>
          <span v-if="!$v.phone.maxLength">يجب أن يتكون رقم الهاتف من 11 رقم على الاكثر</span>
        </div>
      </b-form-group>
    </div>
    <div class="row mt-3">
      <!-- title -->
      <hr class="hr-title" />
      <div class="break-title"><h5 class="mb-4">البيانات الطبية الخاصة بالحاج</h5></div>
      <b-form-group class="col-md-6 mb-3" label=" هل لديه امراض مزمنة : " label-for="is_have_disease" >
        <select
          class="form-control"
          id="is_have_disease"
          v-model="is_have_disease"
          :class="{ 'is-invalid': $v.is_have_disease.$error }"
        >
          <option value="">اختر الاجابة</option>
          <option value="0">لا</option>
          <option value="1">نعم</option>
        </select>
        <div v-if="$v.is_have_disease.$error" class="invalid-feedback">
          <span v-if="!$v.is_have_disease.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
      <b-form-group class="col-md-6 mb-3" label=" الامراض : " label-for="diseases" >
        <multiselect 
          id="diseases" 
          select-label="اختر المرض"
          placeholder="اختر احد الامراض" 
          deselect-label="اظغط هنا لمسح الاختيار"
          selected-label="تم اختياره"
          v-model="diseases"
          :options="list_disease"
          track-by="id"
          label="name"
          :close-on-select="false"
          :clear-on-select="false"
          :multiple="true">
        </multiselect>
      </b-form-group>
    </div>
    <div class="row">
      <b-form-group class="col-md-12 mb-3" label=" الملاحظات : " label-for="note">
        <b-form-textarea
          id="note"
          type="text"
          placeholder=" ادخل الملاحظات"
          v-model="note"
          :class="{ 'is-invalid': $v.note.$error }"
          rows="3"
          max-rows="10"
        ></b-form-textarea>
        <div v-if="$v.note.$error" class="invalid-feedback">
          <span v-if="!$v.note.maxLength">يجب أن تتكون الملاحظات من 500 حرف على الاكثر</span>
        </div>
      </b-form-group>
    </div>
  </div>
  <!-- end page title -->
</template>
